import { Account, Team } from "common";
import { useEffect, useState } from "react";
import { useAPI } from "../api/useAPI";

export const useGetTeamLeaders = ({ team }: { team: Team }) => {
  const api = useAPI();
  const [teamLeaders, setTeamLeaders] = useState<Account[]>([]);
  useEffect(() => {
    (async () => {
      const accounts = await Promise.all(
        team.leaderIds.map((accountId) => api.accountGet({ id: accountId }))
      ).then((resp) => resp.flatMap((r) => r.accounts));
      setTeamLeaders(accounts);
    })();
  }, [api, team.leaderIds]);
  return teamLeaders;
};
